/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATEPROJECT= createAsyncThunk(
  "updateProject/updateProject",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateProjectSlice = createSlice({
  name: "updateProjectSlice",
  initialState: {
    updateProject: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateProject: (state) => {
        state.updateProject.loading = false
        state.updateProject.error = false
        state.updateProject.data = []
        state.updateProject.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEPROJECT.fulfilled, (state, action) => {
      state.updateProject = {
        ...state.updateProject,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEPROJECT.pending, (state, action) => {
      state.updateProject = {
        ...state.updateProject,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEPROJECT.rejected, (state, action) => {
      state.updateProject = {
        ...state.updateProject,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateProjectAction = {
    UPDATEPROJECT,
};

export { updateProjectAction };
export default updateProjectSlice.reducer;
export const {setInitialStateOfupdateProject} = updateProjectSlice.actions